module.exports = __webpack_public_path__ + "static/media/mountain_biking_1920.35165474.webp";